import React, {useState, useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import { ListadoEmpresaBodyMarketplace } from './ListadoEmpresaBodyMarketplace';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import {Riple} from 'react-loading-indicators';

function EmpresasCargadas(prop) {
	const {
		empresasCargadas,
		limite,
		setLimite,
		setPrevLimite,
		getEmpresas_preRegistradas,
		buscarNombre,
		buscarCategoria,
		buscarLocalidad,
		buscarProvincia,
        categorias,
		loading
	} = prop;

	const [loadMore, setLoadMore] = useState(8);

    const [isLoading, setIsLoading] = useState();

	const useStyles = makeStyles({
		root: {
			'border-radius': 10,
		},
	});
	const classes = useStyles();

    const cargarMas = () => {
        setIsLoading(true);
        setLimite(prevLimite => prevLimite + 9);
		setPrevLimite(prevLimite => prevLimite + 9);
        getEmpresas_preRegistradas().finally(() => {
            setIsLoading(false);
            setLoadMore(prevLoadMore => prevLoadMore + 9);
        });
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 50 && !isLoading) {
                cargarMas();
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isLoading]); 

	return (
			<div>
				<div className='listadoContent'>
					<small className='text-muted'>Quizás le pueda interesar</small>
					{!loading ?
						empresasCargadas ?
								empresasCargadas.length > 0 ?
									empresasCargadas.map(
										(empresa, index) =>
											index < loadMore && (
												<ListadoEmpresaBodyMarketplace
													numEmpresa={empresa.id}
													key={empresa.id}
													empresa={empresa}
													rating={false}
													categorias={categorias}
												/>
										)
								):<div className='listado'>
									<div className='listadoEmpresa text-bg-light container-fluid centrador listadoVacio' >
										Todavía no hay servicios disponibles en esta zona. ¡Ayúdanos a expandirnos aquí!
									</div>
								</div>
							:<div className='listado'>
								<div className='listadoEmpresa text-bg-light container-fluid centrador listadoVacio' >
									Todavía no hay servicios disponibles en esta zona. ¡Ayúdanos a expandirnos aquí!
								</div>
							</div>
						:<div className='listado'>
						<div className='listadoEmpresa text-bg-light container-fluid centrador listadoVacio'>
							<Riple color="#23a87e" size="medium" />
						</div>
					</div>
					}
				</div>
				{isLoading && (
					<div className='centrador'>
						<Riple color="#23a87e" size="small" />
					</div>
				)}
			</div>
	);
}

export default EmpresasCargadas;